const state = {
   incomingOrders:{},
}

export default state
